import React from 'react';
import navCss from './navbar.module.scss';


/**
 * Responsible for the logic of the navigation bar
 * 
 */
function Navbar(props) {

  const { value } = props;

  return (
    <>
      <div className={navCss.mobile_bar}>
        <div className={navCss.mobile_bar_menu}>{value}</div>
      </div>
    </>
  );
}
export default Navbar;




//VERSION 3.0 MAPPING MOBILE BAR ICONS

/**
 * Responsible for the logic of the navigation bar
 * 
 */
// function Navbar() {

//   const dispatch = useDispatch()
//   const nav = useSelector(state => state.datareducer.navBar);

//   // added the thing
  

//   const callChangePage = (idOfPage, id, isLink) => 
//   {

//     if (isLink){
//       return (window.parent.location.href = idOfPage);
//     }
//     document.body.style.overflow = "hidden";
//     // removeClass(".cards", "card-animation");
//     // removeClass(".cardlogo", "icon-animation");
//     // removeClass(".cardFinder", "card-text-animation");
  
//     dispatch(tabclixActions.setCurrentPage(idOfPage));
//     // Sends the ifram height to the parent window  
//     document.getElementById("tabclix___div_root").style.height ="100%";
//     window.parent.postMessage("100%", "*");
//   };



// const sortedComponents = sortNoIdComponents(nav);

//   /** useMemo is gonna call the function, and cache the results based on the dependency list */
//   const memonav = useMemo(()=>{

//     const setActive = (id) => {
//      $(".tabclix__OpCl_target").removeClass("active");
//      $(`#${id} > a > div >span`).addClass("active");

//     }
//      return sortedComponents.map(item => {
//       return (
//         <li key={item.id} id={item.id} onClick={() => setActive(item.id)} style={{listStyle:"none"}}>
//           <a
//             className={`${navCss.w_inline_block} navigation-bar-link`}
//             onClick={
//               item.idToGenerate &&
//               (() => callChangePage(item.idToGenerate, item.id, item.link))
//             }
//           >
//             {/* put icon here */}
//             <NavBarIcon {...item}></NavBarIcon>
//             {/* <img loading="lazy" width="28" alt="" src={`${process.env.REACT_APP_ICON_URL}/images/${item.icon}`} /> */}
//           </a>
//         </li>
//       );
//     })
//   }, [nav])

//   return (
//     <>
//       <div className={navCss.mobile_bar}>
//         {/* <div class={`mobile-bar-menu ${currentPAge ===null ? 'top' : 'bottom'}`}> */}
//         <div className={navCss.mobile_bar_menu}>{memonav}</div>
//       </div>
//     </>
//   );
// }
// export default ActionType(Navbar);

// VERSION 2.0 - WITH COMMENTED UNUSED CODE
// import React, { useEffect, useState } from 'react';
// import { NavLink } from 'react-router-dom'
// import axios from 'axios';

// import { useSelector, useDispatch } from 'react-redux';
// import { tabclixActions } from '../../../store/data-slice';
// import logo from '../../media/images/Tabclix_chat-white.svg'
// function Navbar() {


//   const dispatch = useDispatch()
//   const comps = useSelector(state => state.pages);
//   const nav = useSelector(state => state.navBar);
//   const currentPage = useSelector(state => state.currentPage);


//   console.log(nav);

  
//   const callChangePage = (idOfPage) => {
//     console.log(idOfPage)
//     dispatch(tabclixActions.setCurrentState(idOfPage));
//   };


//   const [barData, setBarData] = useState('')
//   // useEffect(() => {
//   //   axios.get(`http://localhost:8000/api/view-nav-elements`).then(res => {
//   //     if (res.data.status === 200) {
//   //       // console.log(res.data.navbar)
//   //       setBarData(res.data.navbar)
//   //     }
//   //   })
//   // }, []);
//   console.log(currentPage)

//   return (
//     <>
//       <div class="mobile-bar">
//         <div class="mobile-bar-menu">
//           {/* {barData && barData.map(item =>  <li key={item.id}> <a href={`/${item.url}`} className="w-inline-block" ><img loading="lazy" width="28" src={`http://localhost:8000/${item.IconUrl}`} alt="" /></a> </li>)} */}
//           {nav && nav.map(item =>
            
//             <li key={item.id}>
//             {/* {import(`../../media/images/${item.icon}`).then(image => console.log(image))} */}
//               {/* <button onClick={() =>increaseHandler(pageDir)}> */}
//               <a onClick={item.idToGenerate && (() =>callChangePage(item.idToGenerate))} className="w-inline-block" >
//                 {/* <img loading="lazy" width="28" alt="" src={`http://localhost:8000/${item.IconUrl}`} /> */}
//                 <img loading="lazy" width="28" alt="" src={logo}/>
//               </a>
//           {/* </button> */}
//             </li>)}
//         </div>
//         <div class="tabclix-brand-3">
//           <div class="brand-tabclix">Tabclix</div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Navbar


// VERSION  1.0 
// import React, { useEffect, useState } from 'react';
// import { NavLink } from 'react-router-dom'
// import axios from 'axios';

// import { useSelector, useDispatch } from 'react-redux';
// import { tabclixActions } from '../../../store/index';

// function Navbar() {


//   const dispatch = useDispatch()
//   const comps = useSelector(state => state.pages);
//   const currentPage = useSelector(state => state.currentPage);

//   const callChangePage = (idOfPage) => {
//     console.log(idOfPage)
//     dispatch(tabclixActions.setCurrentState(idOfPage));
//   };


//   const [barData, setBarData] = useState('')
//   useEffect(() => {
//     axios.get(`http://localhost:8000/api/view-nav-elements`).then(res => {
//       if (res.data.status === 200) {
//         // console.log(res.data.navbar)
//         setBarData(res.data.navbar)
//       }
//     })
//   }, []);
//   console.log(currentPage)

//   return (
//     <>
//       <div class="mobile-bar">
//         <div class="mobile-bar-menu">
//           {/* {barData && barData.map(item =>  <li key={item.id}> <a href={`/${item.url}`} className="w-inline-block" ><img loading="lazy" width="28" src={`http://localhost:8000/${item.IconUrl}`} alt="" /></a> </li>)} */}
//           {barData && barData.map(item =>
            
//             <li key={item.id}>
            
//               {/* <button onClick={() =>increaseHandler(pageDir)}> */}
//               <a onClick={item.idToGenerate && (() =>callChangePage(item.idToGenerate))} className="w-inline-block" >
//                 <img loading="lazy" width="28" src={`http://localhost:8000/${item.IconUrl}`} alt="" />
//               </a>
//           {/* </button> */}
//             </li>)}
//         </div>
//         <div class="tabclix-brand-3">
//           <div class="brand-tabclix">Tabclix</div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Navbar